import { Typography } from '@mui/material'
import React from 'react'
import Resumedata from '../../Utilitize/Resumedata'
import './Footer.css'
function Footer() {
    return (
        <div className="footer">
            <div className="footer_left">
                <Typography>
                   {Resumedata.name}
                </Typography>
            </div>
            <div className="footer_right">
                <Typography>
                  
                      Designed and Developed by <a href="/">shehabuddin tushar </a>
                </Typography>
            </div>
        </div>
    )
}

export default Footer
